module.exports = __webpack_public_path__ + "media/icons/prev-a9196ed3.svg";